import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Controller, useForm } from 'react-hook-form';
import {
  Button,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import { isObjEmpty } from '@utils';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { isValidPhone } from '@brazilian-utils/brazilian-utils';
import useJwt from '@src/auth/jwt/useJwt';
import api from '@services/api';
import { useLoadingGlobal } from '@src/utility/hooks/useLoadingGlobal';
import { toastError, toastSuccess } from '@src/utility/Toast';
import * as masks from '../../../utility/Mask';

export const GeneralTabs = ({ data }) => {
  const { showLoader, hideLoader } = useLoadingGlobal();
  const [hideField, setHideField] = useState(false);

  const GeneralTabsSchema = yup.object().shape({
    name: yup
      .string()
      .required('Nome é obrigatório')
      .matches(
        /^[A-Za-z0-9áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
        'Nome deve conter apenas letras e números'
      ),
    email: yup
      .string()
      .required('Email é obrigatório')
      .email('Por favor inclua um email válido'),
    birthDate: yup.string().required('Data de nascimento é obrigatório'),
    mobile: yup
      .string()
      .required('Celular é obrigatório')
      .transform(masks.phoneMask.transform)
      .test('validatePhone', 'Celular inválido', (value) =>
        isValidPhone(value)
      ),
  });

  const { register, errors, handleSubmit, control, setValue, trigger } =
    useForm({
      resolver: yupResolver(GeneralTabsSchema),
    });

  const onSubmit = async (data) => {
    trigger();
    if (isObjEmpty(errors)) {
      showLoader();

      try {
        await api.put('profile', data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${useJwt.getToken()}`,
          },
        });

        hideLoader();

        toastSuccess({
          title: 'Parabéns',
          description: 'Dados atualizado com sucesso.',
        });
      } catch (error) {
        hideLoader();

        toastError({
          title: 'Atenção',
          description: 'Algo deu errado ao atualizar os dados',
        });
      }
    }
  };

  const handleDataUser = () => {
    const dataUser = localStorage.getItem('userData');
    if (dataUser) {
      const dataUserObject = JSON.parse(dataUser);
      setHideField(dataUserObject.role === 'admin');
    }
  };

  useEffect(() => {
    handleDataUser();
  }, []);

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col sm="12">
            <FormGroup>
              <Label for="name">Nome</Label>
              <Controller
                defaultValue={data.name}
                control={control}
                as={Input}
                id="name"
                name="name"
                placeholder="Name"
                innerRef={register({ required: true })}
                onChange={(e) => setValue('name', e.target.value)}
                className={classnames({
                  'is-invalid': errors.name,
                })}
                disabled={!hideField}
              />
              {errors && errors.name && (
                <FormFeedback>{errors.name.message}</FormFeedback>
              )}
            </FormGroup>
          </Col>
          <Col sm="12">
            <FormGroup>
              <Label for="email">E-mail</Label>
              <Controller
                defaultValue={data.email}
                control={control}
                as={Input}
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                innerRef={register({ required: true })}
                onChange={(e) => setValue('email', e.target.value)}
                className={classnames({
                  'is-invalid': errors.email,
                })}
                disabled={!hideField}
              />
              {errors && errors.email && (
                <FormFeedback>{errors.email.message}</FormFeedback>
              )}
            </FormGroup>
          </Col>
          <Col sm="6">
            <FormGroup>
              <Label for="birth_date">Data de nascimento</Label>
              <Controller
                defaultValue={data.birth_date}
                control={control}
                as={Input}
                type="date"
                id="birthDate"
                name="birthDate"
                innerRef={register({ required: true })}
                onChange={(e) => setValue('birth_date', e.target.value)}
                className={classnames({
                  'is-invalid': errors.birth_date,
                })}
                disabled={!hideField}
              />
              {errors && errors.birth_date && (
                <FormFeedback>{errors.birth_date.message}</FormFeedback>
              )}
            </FormGroup>
          </Col>
          <Col sm="6">
            <FormGroup>
              <Label for="mobile">Celular</Label>
              <Input
                type="tel"
                name="mobile"
                id="mobile"
                placeholder="(99) 99999-9999"
                innerRef={register({ required: true })}
                className={`form-control ${classnames({
                  'is-invalid': errors.mobile,
                })}`}
                onChange={masks.phoneMask.onChange}
                defaultValue={masks.phoneMask.mask(data.mobile)}
                disabled={!hideField}
              />
              {errors && errors.mobile && (
                <FormFeedback>{errors.mobile.message}</FormFeedback>
              )}
            </FormGroup>
          </Col>
          <Col className="mt-2" sm="12">
            <Button.Ripple type="submit" className="mr-1" color="primary">
              Salvar mudanças
            </Button.Ripple>
          </Col>
        </Row>
      </Form>
    </>
  );
};
